module.exports = __webpack_public_path__ + "img/rottentomatoes.8127c21e.png";